<template>
	<span>
		<a href class="btn-like" @click.prevent="open">
			<i class="fa fa-sign-language"></i>
			打赏
		</a>
		<el-dialog :visible.sync="dialogVisible" :append-to-body="true" title="给作者打赏" width="320px">
			<div class="v-reward" v-if="!qrcodeUrl">
				<div class="text-center">打赏金额（元）</div>
				<input class="form-control input-lg text-center" v-model="amount">
				<ul class="opts">
					<li>
						<a @click.prevent="amount=2">2元</a>
					</li>
					<li>
						<a @click.prevent="amount=5">5元</a>
					</li>
					<li>
						<a @click.prevent="amount=10">10元</a>
					</li>
					<li>
						<a @click.prevent="amount=20">20元</a>
					</li>
					<li>
						<a @click.prevent="amount=50">50元</a>
					</li>
					<li>
						<a @click.prevent="amount=100">100元</a>
					</li>
				</ul>
				<div class="pay-btns">
					<!-- <button class="btn btn-block btn-lg btn-alipay" @click.prevent="checkout('alipay')">
						<i class="iconfont icon-alipay-login"></i> 支付宝支付
					</button>-->
					<button class="btn btn-block btn-lg btn-wechat" @click.prevent="checkout('wxpay')">
						<i class="iconfont icon-wxpay"></i> 微信支付
					</button>
				</div>
			</div>
			<div class="v-pay-qrcode text-center" v-else>
				<img :src="qrcodeUrl" width="200" height="200">
				<p style="font-size:18px">请打开微信扫码支付</p>
				<a class="btn btn-default btn-sm" @click="dialogVisible = false">付款成功后点此刷新</a>
			</div>
		</el-dialog>
	</span>
</template>

<script>
export default {
	name: "Reward",
	props: ["refId", "refType"],
	data() {
		return {
			dialogVisible: false,
			amount: 1,
			payment: "wxpay",
			qrcodeUrl: "",
			noticeText: ""
		};
	},
	methods: {
		open() {
			let user = this.$store.getters.user;
			if (!user) {
				return this.util.$emit("login");
			}

			this.amount = 1;
			this.qrcodeUrl = "";
			this.dialogVisible = true;
		},
		checkout(payment) {
			this.$message.closeAll();
			if (this.amount > 0) {
				let tradeNo = Date.parse(new Date());
				this.qrcodeUrl =
					this.axios.apiGateway +
					"/pay/reward?payment=" +
					this.payment +
					"&amount=" +
					this.amount +
					"&trade_no=" +
					Date.parse(new Date());
				this.noticeText = "请使用微信扫码支付";
			} else {
				this.$message.error("请正确输入您要打赏的金额");
			}
		}
	}
};
</script>

<style lang="less">
.v-pay-qrcode {
	padding-bottom: 20px;
}
.v-reward {
	padding: 0 20px 10px 20px;
	.input-lg {
		border: none;
		border-bottom: 1px solid #ddd;
		max-width: 150px;
		font-size: 2.6rem;
		font-weight: bold;
		height: auto;
		line-height: 1;
		padding: 8px;
		margin: 0 auto 30px auto;
		box-shadow: none;
		border-radius: 0;
		color: #d64340;
		&:focus {
			border-color: #666;
		}
	}
	.opts {
		list-style: none;
		padding: 0;
		margin: 0 -5px 20px -5px;
		overflow: hidden;
		li {
			float: left;
			width: 33%;
			a {
				display: block;
				margin: 5px;
				padding: 8px;
				font-size: 16px;
				text-align: center;
				border: solid 1px #ddd;
				border-radius: 4px;
				cursor: pointer;
			}
		}
	}
	.pay-btns {
		margin-bottom: 10px;
		.btn {
			margin-top: 15px;
			color: #fff;
			&.btn-wechat {
				background: #009500;
			}
			&.btn-alipay {
				background: #00aaee;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/Reward.vue